// @ts-check
import React from "react"
import { Skeleton } from "../../../atoms/misc/Skeleton.atom"

/**
 * @param {import("./TableCellSkeleton.component.types").TableCellSkeletonProps} props
 */
export const TableCellSkeleton = (props) => {
  const { column } = props

  /** @type {import("../../types/table").ExpandedColumnMeta | undefined} */
  const columnMeta = column.columnDef.meta

  const className = `table__cell table__cell--skeleton ${columnMeta?.className ?? ""}`

  return (
    <td className={className}>
      <Skeleton />
    </td>
  )
}
